import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationIntentService {
  private openInNewTab = false;

  setOpenInNewTab(value: boolean) {
    this.openInNewTab = value;
  }

  consumeOpenInNewTab(): boolean {
    const value = this.openInNewTab;
    this.openInNewTab = false; // Reset after consuming
    return value;
  }
}
